var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClockGreenIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00033 0.667236C4.41699 0.667236 0.666992 4.41724 0.666992 9.00057C0.666992 13.5839 4.41699 17.3339 9.00033 17.3339C13.5837 17.3339 17.3337 13.5839 17.3337 9.00057C17.3337 4.41724 13.5837 0.667236 9.00033 0.667236ZM12.5003 12.5006L8.16699 9.8339V4.8339H9.41699V9.16724L13.167 11.4172L12.5003 12.5006Z",
    fill: "#2DB875"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockGreenIcon);
export default __webpack_public_path__ + "static/media/clock-green_icon.f95d45568bfd9490f84085fcb25f3130.svg";
export { ForwardRef as ReactComponent };